// extracted by mini-css-extract-plugin
module.exports = {"container":"sync-bar_container__3_qr9","text":"sync-bar_text__3bqUH","title":"sync-bar_title__2qUf8","button":"sync-bar_button__3Habj","saveInfo":"sync-bar_saveInfo__32ya0"};